import React from "react";
import { DataGrid } from "@material-ui/data-grid";

const UserDataGrid = props => {
    return (
        <DataGrid
        onFilterModelChange = {props.onFilterModelChange && props.onFilterModelChange}
            pageSize={10}
            autoHeight="true"
            rowHeight={70}
            disableSelectionOnClick
            density="compact"
            {...props}
        />
    )
};

export default UserDataGrid;